const theme = {
  token: {
    colorPrimary: '#196899',
  },
};

export default theme;
